<template>
    <fullscreen ref="fullscreen"
                v-bind:class="{
        'absolute': fullscreen.fullscreen,
        'h-full': fullscreen.fullscreen,
        'top-0': fullscreen.fullscreen,
        'w-full': fullscreen.fullscreen,
        'z-30': fullscreen.fullscreen,
    }"
                v-model="fullscreen.fullscreen"
                v-bind:teleport="fullscreen.teleport"
                v-bind:page-only="fullscreen.pageOnly">
        <div class="bg-no-repeat bg-cover fullscreen-wrapper"
             v-bind:style="{
                backgroundColor: item && item.background_color ? item.background_color : '#fff',
                backgroundImage: 'url(' + modelImage('inside_right') + ')',
             }">
            <vcs-new-2d-model-side edit-mode="user"
                                   ref="inside-right"
                                   side="inside-right"
                                   v-bind:editable="editable"
                                   v-bind:enable-delete="enableDelete"
                                   v-bind:enable-images="enableImages"
                                   v-bind:enable-stickers="enableStickers"
                                   v-bind:enable-textareas="enableTexts"
                                   v-bind:enable-texts="enableTextareas"
                                   v-bind:enable-z-indexes="enableZIndexes"
                                   v-bind:format="format"
                                   v-bind:language="language"
                                   v-bind:parent-state="parentState"
                                   v-if="item &&
                                         (!item.design || item.design.status !== 'custom') &&
                                         item.elements"
                                   v-model="item.elements"
                                   v-on:clear-state="$emit('clear-state')">
                <template v-slot:side="slotProps">
                    <div class="absolute z-50"
                         v-bind:style="{ left: videoSize.left + '%',
                                         maxHeight: (videoSize.controls_top - videoSize.top - 5) + '%',
                                         top: videoSize.top + '%',
                                         width: videoSize.width + '%', }"
                         v-if="size">
                        <div v-bind:class="{
                                'aspect-landscape': format.split('-')[1] === 'landscape',
                                'aspect-portrait': format.split('-')[1] === 'portrait',
                            }">
                        </div>
                        <div class="absolute h-full inset-0 w-full">
                            <vcs-new-video ref="model-video"
                                           v-bind:autoplay="playing"
                                           v-bind:format="format"
                                           v-bind:key="'model_inside_right_video_' + item.videos[currentVideoIndex].uuid"
                                           v-bind:loop="false"
                                           v-bind:muted="volume === 0"
                                           v-bind:time="videoTime"
                                           v-bind:video="item.videos[currentVideoIndex]"
                                           v-bind:volume="volume"
                                           v-if="item && item.videos && item.videos.length && item.videos[currentVideoIndex]"
                                           v-on:ended="videoEnded"></vcs-new-video>
                            <video class="absolute bg-black left-0 top-0 h-full object-cover w-full"
                                   autoplay
                                   loop
                                   muted
                                   playsinline
                                   v-bind:src="videoPlaceholder"
                                   v-else-if="videoPlaceholder && videoPlaceholder.includes('.mp4')"></video>
                            <img class="absolute bg-black left-0 top-0 h-full object-cover w-full"
                                 v-bind:src="videoPlaceholder"
                                 v-else-if="videoPlaceholder">
                            <div class="relative"
                                 v-else-if="embed">
                                <div v-bind:class="'aspect-' + format.split('-')[1]"></div>
                                <iframe class="absolute bg-black left-0 top-0 h-full object-cover w-full"
                                        v-bind:src="embed"
                                        title="YouTube video player"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                            </div>
                            <template v-else-if="!fullscreen.fullscreen">
                                <div class="absolute bg-black left-0 top-0 h-full object-cover w-full">
                                    <slot name="right"
                                          v-bind:font-point-size="slotProps.fontPointSize"></slot>
                                </div>
                                <div class="absolute h-full inset-0 pointer-events-none w-full"
                                     style="box-shadow: inset 0 0 10px #000;"></div>
                            </template>
                        </div>
                    </div>
                    <div class="absolute flex z-50 select-none"
                         v-bind:class="{
                             'justify-between': !fullscreen.fullscreen,
                             'gap-12': fullscreen.fullscreen,
                             'justify-center': fullscreen.fullscreen,
                         }"
                         v-bind:style="{ left: videoSize.controls_left + '%',
                                         height: videoSize.controls_height + '%',
                                         top: videoSize.controls_top + '%',
                                         width: videoSize.controls_width + '%', }"
                         v-if="size">
                        <div v-for="button in videoSize.controls_buttons"
                             class="aspect-square h-full">
                            <img alt=""
                                 class="cursor-pointer h-full"
                                 v-bind:src="'/img/card-controls/' + button + '.png'"
                                 v-on:click.stop="controlClick(button)">
                        </div>
                        <button class="absolute button top-full"
                                v-if="false &&
                                      item &&
                                      item.videos &&
                                      item.videos.length &&
                                      !editable"
                                v-on:click="toggle">
                            {{ fullscreen.fullscreen ? 'exit fullscreen' : 'request fullscreen' }}
                        </button>
                    </div>
                    <div
                        class="h-[20.48%] left-[11.27%] relative top-[89.76%] -translate-x-1/2 -translate-y-1/2 w-[22.54%] z-50
                               *:absolute *:aspect-square *:bg-black *:rounded-full *:-translate-x-1/2 *:-translate-y-1/2 *:w-[6%]"
                        v-if="speaker"
                    >
                        <div class="left-[50%] top-[50%]"></div>
                        <div class="left-[35%] top-[32.5%]"></div>
                        <div class="left-[65%] top-[32.5%]"></div>
                        <div class="left-[35%] top-[67.5%]"></div>
                        <div class="left-[65%] top-[67.5%]"></div>
                        <div class="left-[75%] top-[50%]"></div>
                        <div class="left-[25%] top-[50%]"></div>
                    </div>
                </template>
            </vcs-new-2d-model-side>
        </div>
    </fullscreen>
</template>

<script>
export default {
    name: "vcs-new-2d-model-inside-right",
    computed: {
        videoSize: function () {
            if (this.item &&
                this.item.size)
                return this.item.size;
            return this.size;
        },

        storageDomain: function () {
            return window.storage_url;
            var domain = window.location.hostname.split('.');
            if (domain.length === 2)
                return 'https://storage.' + domain[0] + '.' + domain[1];
            return 'https://storage.' + domain[1] + '.' + domain[2];
        },
    },
    data: function () {
        return {
            currentVideoIndex: 0,
            fullscreen: {
                fullscreen: false,
                teleport: true,
                pageOnly: true,
            },
            playing: false,
            uncachedUrl: null,
            volume: 0,
        };
    },
    methods: {
        controlClick: function (button) {
            var buttonSegments = button.split('-');
            var method = 'controlClick';
            for (var key in buttonSegments)
                method += buttonSegments[key].charAt(0).toUpperCase() + buttonSegments[key].slice(1)
            this[method]();
            this.$emit('control-click', button);
        },
        controlClickNext: function () {
            if (this.item.videos[this.currentVideoIndex + 1])
                return this.currentVideoIndex++;
            this.currentVideoIndex = 0;
        },
        controlClickPause: function () {
            this.playing = false;

            if (this.$refs['model-video'])
                this.$refs['model-video'].videoPause();
        },
        controlClickPlay: function () {
            this.playing = true;

            if (this.$refs['model-video'])
                this.$refs['model-video'].videoPlay();
        },
        controlClickPlayPause: function () {
            if (this.playing)
                return this.controlClickPause();
            this.controlClickPlay();
        },
        controlClickPrevious: function () {
            if (this.item.videos.length === 1)
                return this.$refs['model-video']?.videoPlayFromBeginning();
            if (this.currentVideoIndex > 0)
                return this.currentVideoIndex--;
            this.currentVideoIndex = this.item.videos.length - 1;
        },
        controlClickVolumeUp: function () {
            this.volume += 10;
            if (this.volume > 100)
                this.volume = 100;
        },
        controlClickVolumeDown: function () {
            this.volume -= 10;
            if (this.volume < 0)
                this.volume = 0;
        },
        getFullScreenParameters: function (asUrlParams = true) {
            if (asUrlParams)
                return '?video=' + this.currentVideoIndex + '&video-time=' + this.$refs['model-video'].currentTime;

            return {
                video: this.currentVideoIndex,
                videoTime: this.$refs['model-video'].currentTime,
            };
        },
        goFullScreen: function () {
            this.$refs['model-video'].goFullScreen();
        },
        videoEnded: function () {
            this.controlClickNext();
            if (this.playing && this.item.videos.length === 1)
                this.controlClickPlay();
        },

        modelImage: function (image) {
            if (this.item && this.item.design)
                return this.storageDomain + '/designs/' + this.item.design.uuid + '/image_' + image + '/retina' + this.uncachedUrl;
            return '#';
        },

        toggle() {
            this.fullscreen.fullscreen = !this.fullscreen.fullscreen
        },
    },
    created: function () {
        // Manage cache
        this.uncachedUrl = (this.uncached ? '?' + (new Date).getTime() : '');
    },
    mounted: function () {
        // Set initial video
        if (this.item &&
            this.item.videos &&
            this.item.videos[this.video] !== 'undefined')
            this.currentVideoIndex = this.video;

        // Auto play
        if (this.autoplay)
            this.controlClickPlay();

        // Unmute
        if (!this.muted)
            this.volume = 50;

        document.addEventListener('mousedown', () => {
            if (!this.fullscreen.fullscreen)
                this.fullscreen.pageOnly = false;
        }, true)
    },
    props: {
        autoplay: {
            default: true,
            required: false,
            type: Boolean,
        },
        editable: {
            default: false,
            required: false,
            type: Boolean,
        },
        editMode: {
            default: 'user',
            required: false,
            type: String,
        },
        embed: {
            default: null,
            required: false,
            type: String,
        },
        enableDelete: {
            default: true,
            required: false,
            type: Boolean,
        },
        enableImages: {
            default: true,
            required: false,
            type: Boolean,
        },
        enableStickers: {
            default: true,
            required: false,
            type: Boolean,
        },
        enableTextareas: {
            default: true,
            required: false,
            type: Boolean,
        },
        enableTexts: {
            default: true,
            required: false,
            type: Boolean,
        },
        enableZIndexes: {
            default: true,
            required: false,
            type: Boolean,
        },
        format: {
            default: 'a5-landscape',
            required: false,
            type: String,
        },
        fullScreen: {
            default: false,
            required: false,
            type: Boolean,
        },
        item: {
            default: null,
            required: false,
            type: Object,
        },
        language: {
            default: 'en',
            required: false,
            type: String,
        },
        loop: {
            default: true,
            required: false,
            type: Boolean,
        },
        muted: {
            default: true,
            required: false,
            type: Boolean,
        },
        parentState: {
            default: null,
            type: String,
            required: false,
        },
        size: {
            default: null,
            required: false,
            type: Object,
        },
        speaker: {
            default: false,
            required: false,
            type: Boolean,
        },
        video: {
            default: 0,
            required: false,
            type: Number,
        },
        videoPlaceholder: {
            default: null,
            required: false,
            type: String,
        },
        videoTime: {
            default: 0,
            required: false,
            type: Number,
        },
    },
    watch: {
        'fullscreen.fullscreen': {
            handler: function (newVal, oldVal) {
                if (this.$refs['model-video'])
                    setTimeout(() => this.$refs['model-video'].calculateDimensions(), 50);

                if (newVal)
                    this.$emit('enter-fullscreen');
                else
                    this.$emit('exit-fullscreen');
            },
        },
        'item.videos': {
            deep: true,
            handler: function (newVal, oldVal) {
                if (newVal !== undefined &&
                    newVal &&
                    newVal.length > 0)
                    this.currentVideoIndex = newVal.length - 1;
            },
        },
    },
}
</script>

<style scoped>

.fullscreen-wrapper {
    width: 100%;
    height: 100%;
}
</style>